"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LedgerHeader = void 0;
require("./ledgerHeader.less");
const React = require("react");
const moment = require("moment");
const ledger_1 = require("shared/ledger");
const ui_1 = require("client/components/ui");
const mobx_1 = require("mobx");
const button_1 = require("client/components/material/button");
const date_picker_1 = require("client/components/material/date-picker/date-picker");
const select_1 = require("client/components/material/select");
const text_area_1 = require("client/components/material/text-area");
const text_field_1 = require("client/components/material/text-field");
const modal_1 = require("client/components/modal");
// import { LedgerReport } from "client/modules/ledger/modules/ledger-list/components/ledgerReport/ledgerReport";
const store_1 = require("client/modules/eob/store");
const store_2 = require("client/modules/ledger/store");
const mobx_react_1 = require("mobx-react");
const util_1 = require("shared/util");
const store_3 = require("client/modules/sites/modules/sites-list/store");
const store_4 = require("client/modules/users/store");
let LedgerHeader = class LedgerHeader extends React.Component {
    constructor() {
        super(...arguments);
        this.siteId = 0;
        this.siteIdAddModal = 0;
        this.currentBalance = 0;
        this.ledgerEntryId = -1;
        this.filterText = "";
        this.filterDate = "";
        this.startDate = "";
        this.endDate = "";
        this.addDate = "";
        this.amount = "";
        this.notes = "";
        this.source = ledger_1.SourceType.default;
        this.refType = ledger_1.ReferenceType.default;
        this.reference = "";
        this.currentUserId = 0; // so IMB users can be recorded in ledger when entering eob details.
        //   @observable
        //   public claimStatus: ClaimStatus;
        this.editModal = false;
        this.addModal = false;
        this.submitted = false;
        this.ledgerDateisOlder = false;
        this.options = [
            {
                id: 1,
                label: "Starting balance - adjustment",
                value: ledger_1.SourceType.startBalanceAdjust
            },
            {
                id: 2,
                label: "Claim - adjustment",
                value: ledger_1.SourceType.claimAdjust
            },
            {
                id: 3,
                label: "Order - adjustment",
                value: ledger_1.SourceType.orderAdjust
            },
            {
                id: 4,
                label: "POS fee - adjustment",
                value: ledger_1.SourceType.posfeeAdjust
            },
            {
                id: 5,
                label: "DIR fee - adjustment",
                value: ledger_1.SourceType.dirfeeAdjust
            },
            {
                id: 6,
                label: "Service fee - adjustment",
                value: ledger_1.SourceType.imbfeeAdjust
            },
            {
                id: 7,
                label: "Dispersement - adjustment",
                value: ledger_1.SourceType.dispersementAdjust
            },
            {
                id: 8,
                label: "Order Tracking Cost - adjustment",
                value: ledger_1.SourceType.OrderTrackingCostAdjust
            },
            {
                id: 9,
                label: "Billing - adjustment",
                value: ledger_1.SourceType.billingAdjustment
            },
            {
                id: 10,
                label: "Transaction fee - adjustment",
                value: ledger_1.SourceType.transactionfeeAdjust
            }
        ].sort((a, b) => a.label > b.label ? 1 : -1);
        this.refTypeOptions = [
            {
                id: 1,
                label: "RX Number",
                value: ledger_1.ReferenceType.rxnumber
            },
            {
                id: 2,
                label: "Purchase Order Number",
                value: ledger_1.ReferenceType.ordernumber
            },
            {
                id: 3,
                label: "Check Number",
                value: ledger_1.ReferenceType.checknumber
            },
            {
                id: 4,
                label: "Balance Adjustment",
                value: ledger_1.ReferenceType.adjustment
            },
            {
                id: 5,
                label: "EOB Id",
                value: ledger_1.ReferenceType.headernumber
            },
            {
                id: 6,
                label: "Invoice Number",
                value: ledger_1.ReferenceType.invoicenumber
            },
            {
                id: 7,
                label: "Claim Order Id",
                value: ledger_1.ReferenceType.ClaimOrderId
            },
            {
                id: 8,
                label: "Pharmacy Id",
                value: ledger_1.ReferenceType.SiteId
            }
        ].sort((a, b) => a.label > b.label ? 1 : -1);
        this.runFunc = () => {
            if (this.siteIdAddModal) {
                // console.log("inside runfunc");
                // eobStore.updateLedgerFlag(this.siteIdAddModal, 0);
                store_2.ledgerStore.deleteNullLedgerEntry(this.siteIdAddModal, this.ledgerEntryId);
            }
        };
        this.headerToggle = () => {
            this.editModal = !this.editModal;
        };
        this.headerAddToggle = () => {
            this.addModal = !this.addModal;
        };
        this.handleLoader = () => {
            store_2.ledgerStore.showLoader = !store_2.ledgerStore.showLoader;
        };
        // private handleSearch = () => (
        //   event: React.ChangeEvent<{}>,
        //   value: string
        // ) => {
        //   // this.props.callBack(value, this.props.filterDate || '');
        // };
        this.handleChangeSite = (id) => {
            this.siteId = Number(id);
        };
        this.handleChangeSiteAddModal = async (id) => {
            var _a;
            if (this.siteIdAddModal !== 0) {
                await store_2.ledgerStore.deleteNullLedgerEntry(this.siteIdAddModal, this.ledgerEntryId);
            }
            this.siteIdAddModal = Number(id);
            store_1.eobStore.showLoader = true;
            await store_1.eobStore.loadLedgerBalance({
                siteId: this.siteIdAddModal,
                sourcePage: "ledger adjustment",
                userId: this.currentUserId
            });
            this.ledgerDateisOlder = await store_2.ledgerStore.shouldHideStartBalanceAdjustment(this.siteIdAddModal);
            this.currentBalance = ((_a = store_1.eobStore.ledgerBalance) === null || _a === void 0 ? void 0 : _a.toFixed(2)) || "0.00";
            this.ledgerEntryId = store_1.eobStore.ledgerEntryId;
        };
        this.handleChangeSourceAddModal = (value) => {
            // console.log("value", value);
            this.source = value;
        };
        this.handleChangeRefTypeAddModal = (value) => {
            // console.log("value", value);
            this.refType = value;
        };
        //   private handleChangeClaimStatus = (value: ClaimStatus) => {
        //     this.claimStatus = value;
        //     console.log(this.claimStatus);
        //   };
        this.handleSubmitQuery = async () => {
            this.handleLoader();
            this.headerToggle();
            // await ledgerStore.loadLedger(this.siteId, this.startDate, this.endDate);
            await this.recursiveFunc(this.siteId, this.startDate, this.endDate);
        };
        this.handleAddQuery = async () => {
            this.submitted = true;
            this.handleLoader();
            this.headerAddToggle();
            // if (!this.addDate) {
            //   // console.log("empty date field");
            //   const date = new Date().toDateString();
            //   this.addDate = moment(date).format("YYYY-MM-DD");
            // }
            // await ledgerStore.adjustLedger(
            //   this.siteIdAddModal,
            //   this.amount,
            //   this.source,
            //   this.currentUserId,
            //   this.ledgerEntryId
            // );
            await this.recursiveFuncAdjustment(this.siteIdAddModal, this.amount, this.source, this.currentUserId, this.ledgerEntryId, this.notes, this.refType, this.reference);
            // await eobStore.updateLedgerFlag(this.siteIdAddModal, 0);
            // console.log("add query submitted");
            // await eobStore.loadLedgerBalance({
            //   siteId: this.siteIdAddModal
            // });
            // this.currentBalance = eobStore.ledgerBalance;
            // this.ledgerEntryId = eobStore.ledgerEntryId;
        };
        this.handleClickTodayStart = () => {
            const date = new Date().toDateString();
            this.startDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayEnd = () => {
            const date = new Date().toDateString();
            this.endDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickTodayAdd = () => {
            const date = new Date().toDateString();
            this.addDate = moment(date).format("YYYY-MM-DD");
        };
        this.handleClickClearStart = () => {
            this.startDate = "";
        };
        this.handleClickClearEnd = () => {
            this.endDate = "";
        };
        this.handleClickClearAdd = () => {
            this.addDate = "";
        };
        this.handleDatePickerChangeStart = (value) => {
            this.startDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeEnd = (value) => {
            this.endDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleDatePickerChangeAdd = (value) => {
            this.addDate = moment(value).format("YYYY-MM-DD");
        };
        this.handleCancel = () => {
            // console.log("cancel at top");
            this.siteId = 0;
            this.startDate = "";
            this.endDate = "";
            this.editModal = false;
            // this.siteIdAddModal = 0;
            // this.amount = "";
            // this.source = "";
            // this.ledgerEntryId = -1;
            // this.currentBalance = 0;
            this.addModal = false;
            // this.siteId = 0;
        };
        this.handleClose = async () => {
            // console.log("close at top");
            // await eobStore.updateLedgerFlag(this.siteIdAddModal, 0);
            if (!this.submitted) {
                await store_2.ledgerStore.deleteNullLedgerEntry(this.siteIdAddModal, this.ledgerEntryId);
            }
            this.siteIdAddModal = 0;
            this.amount = "";
            this.notes = "";
            this.source = ledger_1.SourceType.default;
            this.refType = ledger_1.ReferenceType.default;
            this.reference = "";
            this.ledgerEntryId = -1;
            this.currentBalance = 0;
            this.submitted = false;
        };
        this.handleClickAll = async () => {
            const date = await store_2.ledgerStore.getFirstDate();
            // console.log("date is ", date);
            // console.log(date.Date);
            this.startDate = moment(date).format("YYYY-MM-DD");
            // console.log("this startdate--------------->", this.startDate);
        };
        this.handleChangeString = (fieldName) => (event, value) => {
            if (fieldName === "amount") {
                this.amount = value;
            }
            if (fieldName === "notes") {
                this.notes = value;
            }
            if (fieldName === "reference") {
                this.reference = value;
            }
        };
    }
    componentWillMount() {
        const date = new Date().toDateString();
        this.addDate = moment(date).format("MM/DD/YYYY");
        this.currentUserId =
            store_4.usersStore.user && store_4.usersStore.user.value && store_4.usersStore.user.value.id
                ? store_4.usersStore.user.value.id
                : 0;
    }
    async componentDidMount() {
        if (store_4.usersStore.user.value &&
            store_4.usersStore.user.value.siteUser &&
            store_4.usersStore.user.value.siteId) {
            this.siteId = store_4.usersStore.user.value.siteId;
            this.handleChangeSite(String(this.siteId));
        }
        else {
            await store_3.sitesListStore.loadSitesNoRelation();
        }
        // console.log("component did mount");
        window.addEventListener("beforeunload", this.runFunc);
    }
    componentWillUnmount() {
        // console.log("ledger adjustment will unmount");
        window.removeEventListener("beforeunload", this.runFunc);
    }
    async recursiveFunc(siteId, startDate, endDate) {
        // console.log("inside recursive function");
        const funcDone = await store_2.ledgerStore.loadLedger(siteId, startDate, endDate);
        // console.log("inside recursive function result", funcDone);
        let timer;
        if (!funcDone) {
            timer = setTimeout(() => {
                this.recursiveFunc(siteId, startDate, endDate);
            }, 1000);
        }
        if (funcDone) {
            // console.log("inside clear timeout");
            clearTimeout(timer);
        }
        return funcDone;
    }
    async recursiveFuncAdjustment(siteId, amount, source, userId, ledgerEntryId, notes, refType, reference) {
        // console.log("inside recursive function");
        const funcDone = await store_2.ledgerStore.adjustLedger(siteId, amount, source, userId, ledgerEntryId, notes, refType, reference);
        // console.log("inside recursive function result", funcDone);
        let timer;
        if (!funcDone) {
            timer = setTimeout(() => {
                this.recursiveFuncAdjustment(siteId, amount, source, userId, ledgerEntryId, notes, refType, reference);
            }, 1000);
        }
        if (funcDone) {
            // console.log("inside clear timeout");
            clearTimeout(timer);
            if (!store_2.ledgerStore.ledgerData.error) {
                this.siteIdAddModal = 0;
                this.ledgerEntryId = -1;
            }
        }
        return funcDone;
    }
    get availableOptions() {
        const options = [];
        if (store_3.sitesListStore.sites.value) {
            options.push({ id: 0, label: "All Pharmacies", value: "0" });
            store_3.sitesListStore.sites.value.forEach((site, i) => options.push({
                id: i + 1,
                label: site.displayName || site.name,
                value: site.id.toString()
            }));
        }
        return options;
    }
    get availableOptionsAddModal() {
        return store_3.sitesListStore.sites.value
            ? store_3.sitesListStore.sites.value.map((site, i) => ({
                id: i,
                label: site.displayName || site.name,
                value: site.id.toString()
            }))
            : [];
    }
    get availableSourceOptions() {
        let options = this.options;
        if (this.ledgerDateisOlder) {
            options = options.filter((item) => item.id !== 1);
        }
        return options;
    }
    render() {
        // const { label = "Search", title, withDatePicker } = this.props;
        const { title, withDatePicker } = this.props;
        const buttons = [];
        buttons.push(React.createElement(button_1.MaterialButton, { className: "btnCancel", onClick: this.handleCancel }, "Cancel"), "Submit");
        return store_4.usersStore.permissions.ReadLedger ?
            React.createElement(React.Fragment, null,
                React.createElement("div", null,
                    React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                        title &&
                            React.createElement("div", { className: "filter-bar__title", style: { margin: "10px" } },
                                React.createElement("div", { className: "filter-bar__title-text" }, title)),
                        React.createElement(button_1.MaterialButton, { onClick: () => this.headerToggle(), style: { margin: "10px" } }, "Query Options"),
                        React.createElement(button_1.MaterialButton, { onClick: () => this.headerAddToggle(), style: { margin: "10px" } }, "Add Ledger Adjustment")),
                    this.editModal ?
                        React.createElement(modal_1.Modal, { onCancel: this.headerToggle, maxHeight: "70%", top: "100px" },
                            React.createElement(ui_1.UiForm, { buttons: buttons, 
                                // loading={false}
                                // status={'Clean'}
                                saved: "Saved", onSubmit: this.handleSubmitQuery, isChanged: () => false, error: "", warning: "" },
                                React.createElement("div", { className: "filter-bar" },
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "" },
                                            React.createElement(select_1.MaterialSelect, { options: this.availableOptions, required: true, searchable: true, label: "Pharmacy", onSelect: this.handleChangeSite, onInputChange: (e) => {
                                                    util_1.pharmacyDropDownHandler({
                                                        id: Number(this.siteId),
                                                        search: e
                                                    });
                                                }, value: String(this.siteId) || "", width: "100%" })),
                                        React.createElement("div", null,
                                            React.createElement("div", { className: "filter-bar" },
                                                withDatePicker &&
                                                    React.createElement("div", { className: "filter-bar" },
                                                        React.createElement("h3", null, "Start Date: "),
                                                        React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "Start Date", required: true, value: this.startDate || "", onChange: this.handleDatePickerChangeStart }),
                                                        React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                                                            React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayStart }, "Today"),
                                                            React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", onClick: this.handleClickAll }, "First Recorded Date"),
                                                            React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearStart }, "Clear"))),
                                                withDatePicker &&
                                                    React.createElement("div", { className: "filter-bar" },
                                                        React.createElement("h3", null, "End Date: "),
                                                        React.createElement(date_picker_1.MaterialDatePicker, { className: "filter-bar__date-picker", label: "End Date", required: true, value: this.endDate || "", onChange: this.handleDatePickerChangeEnd }),
                                                        React.createElement("div", { style: { display: "flex", flexDirection: "row" } },
                                                            React.createElement(button_1.MaterialButton, { className: "filter-bar__today-button", primary: true, onClick: this.handleClickTodayEnd }, "Today"),
                                                            React.createElement(button_1.MaterialButton, { className: "filter-bar__clear-button", onClick: this.handleClickClearEnd }, "Clear")))))))))
                        : null,
                    this.addModal ?
                        React.createElement(modal_1.Modal, { onCancel: this.headerAddToggle, onClose: this.handleClose, height: "70%", top: "100px" },
                            React.createElement(ui_1.UiForm, { buttons: buttons, 
                                // loading={false}
                                // status={'Clean'}.handleClose.handleClose
                                saved: "Saved", onSubmit: this.handleAddQuery, isChanged: () => false, error: "", warning: "", shouldDisableSave: store_1.eobStore.showLoader },
                                React.createElement("div", { className: "add-bar" },
                                    React.createElement("div", null,
                                        React.createElement("div", { className: "" },
                                            React.createElement(select_1.MaterialSelect, { options: this.availableOptionsAddModal, required: true, searchable: true, label: "Pharmacy", disabled: store_1.eobStore.showLoader, onSelect: this.handleChangeSiteAddModal, onInputChange: (e) => {
                                                    util_1.pharmacyDropDownHandler({
                                                        id: Number(this.siteIdAddModal),
                                                        search: e
                                                    });
                                                }, value: String(this.siteIdAddModal) || "", width: "100%" })),
                                        React.createElement("br", null),
                                        React.createElement("div", null,
                                            React.createElement("div", { className: "add-bar" },
                                                React.createElement("div", { className: "add-bar" },
                                                    React.createElement("div", null,
                                                        "Date: ",
                                                        this.addDate || "")))),
                                        React.createElement("br", null),
                                        store_1.eobStore.showLoader ?
                                            React.createElement(ui_1.UiLoadingIndicator, { className: "loader" })
                                            : null,
                                        React.createElement("div", null,
                                            "Current Balance: ",
                                            this.currentBalance || ""),
                                        React.createElement("div", null,
                                            React.createElement("div", null,
                                                React.createElement("br", null),
                                                React.createElement("div", null, "Enter amount to adjust ledger balance: "),
                                                React.createElement(text_field_1.MaterialTextField, { className: "add-amount", required: true, label: "Amount", disabled: store_1.eobStore.showLoader, onChange: this.handleChangeString("amount"), value: this.amount || "" })),
                                            React.createElement("div", null,
                                                React.createElement("br", null),
                                                React.createElement("div", null, "Source: "),
                                                React.createElement(select_1.MaterialSelect, { options: this.availableSourceOptions, className: "add-source", required: true, searchable: true, label: "Source", disabled: store_1.eobStore.showLoader, onSelect: this.handleChangeSourceAddModal, value: this.source || "", width: "100%" }),
                                                React.createElement("br", null)),
                                            React.createElement("div", null,
                                                React.createElement("br", null),
                                                React.createElement("div", null, "Reference Type: "),
                                                React.createElement(select_1.MaterialSelect, { options: this.refTypeOptions, className: "add-source", required: true, searchable: true, label: "Reference Type", disabled: store_1.eobStore.showLoader, onSelect: this.handleChangeRefTypeAddModal, value: this.refType || "", width: "100%" }),
                                                React.createElement("br", null)),
                                            React.createElement("div", null,
                                                React.createElement("br", null),
                                                React.createElement("div", null, "Reference: "),
                                                React.createElement(text_field_1.MaterialTextField, { className: "add-source", required: this.refType !== ledger_1.ReferenceType.default && this.refType !== ledger_1.ReferenceType.adjustment, label: "Reference", onChange: this.handleChangeString("reference"), value: this.reference || "" }),
                                                React.createElement("br", null)),
                                            React.createElement("div", null,
                                                React.createElement("br", null),
                                                React.createElement("div", null, "Notes: "),
                                                React.createElement(text_area_1.MaterialTextArea, { className: "add-notes", placeholder: "Reason for adjustment (optional)", onChange: this.handleChangeString("notes"), value: this.notes || "" }),
                                                React.createElement("br", null),
                                                React.createElement("br", null)))))))
                        : null,
                    store_2.ledgerStore.showLoader ? React.createElement(ui_1.UiLoadingIndicator, null) : null))
            :
                store_4.usersStore.showLock();
    }
    exportDisabled() {
        if (store_2.ledgerStore.ledgerData.value.length) {
            return false;
        }
        return true;
    }
};
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "siteId", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "siteIdAddModal", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "currentBalance", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "ledgerEntryId", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "filterText", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "filterDate", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "startDate", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "endDate", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "addDate", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "amount", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "notes", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "source", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "refType", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "reference", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "currentUserId", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "editModal", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "addModal", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "submitted", void 0);
__decorate([
    mobx_1.observable
], LedgerHeader.prototype, "ledgerDateisOlder", void 0);
__decorate([
    mobx_1.computed
], LedgerHeader.prototype, "availableOptions", null);
__decorate([
    mobx_1.computed
], LedgerHeader.prototype, "availableOptionsAddModal", null);
__decorate([
    mobx_1.computed
], LedgerHeader.prototype, "availableSourceOptions", null);
LedgerHeader = __decorate([
    mobx_react_1.observer
], LedgerHeader);
exports.LedgerHeader = LedgerHeader;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/ledger/modules/ledger-list/components/ledgerHeader/ledgerHeader.tsx
// module id = 3717
// module chunks = 0